/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Signals_Powered_ByInputs */

const en_directory_detail_signals_powered_by = /** @type {(inputs: Directory_Detail_Signals_Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powered by Seek AI Benchmarks`)
};

const zh_directory_detail_signals_powered_by = /** @type {(inputs: Directory_Detail_Signals_Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`由 Seek AI 基准评分提供支持`)
};

/**
* | output |
* | --- |
* | "Powered by Seek AI Benchmarks" |
*
* @param {Directory_Detail_Signals_Powered_ByInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_signals_powered_by = /** @type {((inputs?: Directory_Detail_Signals_Powered_ByInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Signals_Powered_ByInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_signals_powered_by(inputs)
	return zh_directory_detail_signals_powered_by(inputs)
});
export { directory_detail_signals_powered_by as "directory.detail.signals.powered_by" }